import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CreditCardFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M5.09 18.15c.35.99 1.32 1.7 2.48 1.7h8.95c1.15 0 2.12-.72 2.48-1.7H5.09ZM18.6 3.96H5.4c-1.74 0-3.16 1.42-3.16 3.16v6.94c0 1.74 1.42 3.16 3.16 3.16h13.2c1.74 0 3.16-1.42 3.16-3.16V7.12c0-1.74-1.42-3.16-3.16-3.16Zm-7.36 9.32H6c-.44 0-.8-.36-.8-.8 0-.44.36-.8.8-.8h5.25c.44 0 .8.36.8.8 0 .44-.36.8-.8.8h-.01Zm6.47-4.29H6c-.44 0-.8-.36-.8-.8 0-.44.36-.8.8-.8h11.71c.44 0 .8.36.8.8 0 .44-.36.8-.8.8Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CreditCardFilled
